import { Dexie, type EntityTable } from 'dexie';
import type { OutboxItem, OutboxStorage } from './outbox.ts';

/**
 * IndexedDB storage for the offline outbox (survives closing the app and phone restarts).
 * Schema changes: add a NEW `db.version(n)` block — never edit an existing one.
 */
type OutboxDb = Dexie & { outbox: EntityTable<OutboxItem, 'id'> };

export function createDexieOutboxStorage(name = 'bnb-web'): OutboxStorage {
  const db = new Dexie(name) as OutboxDb;
  db.version(1).stores({ outbox: 'id, createdAt, status' });
  return {
    async put(item) {
      await db.outbox.put(item);
    },
    async remove(id) {
      await db.outbox.delete(id);
    },
    async all() {
      return db.outbox.toArray();
    },
  };
}
